import React, { useState, useEffect } from "react";
import "./App.css";
import logo from "./assets/img/logo-m.png";
import Image1 from "./assets/img/s1.jpeg";
import Image2 from "./assets/img/s2.jpeg";
import Image3 from "./assets/img/s3.jpeg";
import Image4 from "./assets/img/s4.jpeg";
import Image5 from "./assets/img/s5.jpeg";
import Image6 from "./assets/img/s6.jpeg";
import Image7 from "./assets/img/s7.jpeg";
import Image8 from "./assets/img/s8.jpeg";
import Image9 from "./assets/img/s9.jpeg";
import Image10 from "./assets/img/s10.jpeg";
import Image11 from "./assets/img/s11.jpeg";
import Image12 from "./assets/img/s12.jpeg";
import Image13 from "./assets/img/s13.jpeg";
import Image14 from "./assets/img/s14.jpeg";

import eventImage1 from "./assets/img/iran-solo-country.jfif";
import eventImage2 from "./assets/img/showcasing-if-irani-artist.jfif";
import eventImage3 from "./assets/img/showcase-mashhad-e-muqadas.jfif";
import eventImage4 from "./assets/img/hyderabad-and-sukkur.jfif";
import logopng from "./assets/img/logo-p.jfif";
import EmailSender from "./api/EmailSender";

function App() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    companySite: "",
    businessField: "",
    logo: null,
  });

  // Email sender hook
  const { sendEmail } = EmailSender();

  // Form submission states
  const [isProcessing, setIsProcessing] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);

  // Slideshow state
  const [currentSlide, setCurrentSlide] = useState(0);

  // Mobile menu state
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Event images for slideshow
  const eventImages = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8,
    Image9,
    Image10,
    Image11,
    Image12,
    Image13,
    Image14,
  ];

  // Auto-advance slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % eventImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [eventImages.length]);

  // Navigate to next slide
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % eventImages.length);
  };

  // Navigate to previous slide
  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + eventImages.length) % eventImages.length
    );
  };

  // Smooth scroll handler
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Remove https:// prefix from companySite if user adds it
    let processedValue = value;
    if (name === "companySite") {
      processedValue = value.replace(/^https?:\/\//i, "");
    }
    setFormData({ ...formData, [name]: processedValue });
  };
  const handleLogoUpload = (e) => {
    setFormData({ ...formData, logo: e.target.files[0] });
  };

  // Email template for admin notification
  const generateAdminEmailTemplate = (data) => {
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .container { max-width: 600px; margin: 0 auto; padding: 20px; }
          .header { background: linear-gradient(135deg, #0222a8 0%, #14be69 100%); color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
          .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
          .info-row { margin: 15px 0; padding: 10px; background: white; border-radius: 5px; }
          .label { font-weight: bold; color: #0222a8; }
          .footer { text-align: center; margin-top: 20px; font-size: 12px; color: #666; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>🎫 New Badge Registration</h1>
            <p>Xpand Elevate Event</p>
          </div>
          <div class="content">
            <p>A new attendee has registered for the event:</p>
            <div class="info-row"><span class="label">Name:</span> ${
              data.name
            }</div>
            <div class="info-row"><span class="label">Email:</span> ${
              data.email
            }</div>
            <div class="info-row"><span class="label">Phone:</span> ${
              data.phone
            }</div>
            <div class="info-row"><span class="label">Company:</span> ${
              data.companyName
            }</div>
            <div class="info-row"><span class="label">Website:</span> ${
              data.companySite || "N/A"
            }</div>
            <div class="info-row"><span class="label">Designation:</span> ${
              data.businessField
            }</div>
            <div class="info-row"><span class="label">Registration Time:</span> ${new Date(
              data.timestamp
            ).toLocaleString()}</div>
          </div>
          <div class="footer">
            <p>This is an automated notification from Xpand Elevate Badge System</p>
          </div>
        </div>
      </body>
      </html>
    `;
  };

  // Email template for user confirmation
  const generateUserEmailTemplate = (data) => {
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .container { max-width: 600px; margin: 0 auto; padding: 20px; }
          .header { background: linear-gradient(135deg, #0222a8 0%, #14be69 100%); color: white; padding: 30px; text-align: center; border-radius: 10px 10px 0 0; }
          .content { background: #f9f9f9; padding: 30px; border-radius: 0 0 10px 10px; }
          .success-badge { font-size: 48px; text-align: center; margin: 20px 0; }
          .info-box { background: white; padding: 20px; border-radius: 5px; margin: 20px 0; border-left: 4px solid #0222a8; }
          .footer { text-align: center; margin-top: 20px; font-size: 12px; color: #666; }
          .button { display: inline-block; padding: 12px 24px; background: #0222a8; color: white; text-decoration: none; border-radius: 5px; margin-top: 15px; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>✓ Your Badge is Ready!</h1>
            <p>Xpand Elevate Event</p>
          </div>
          <div class="content">
            <div class="success-badge">🎫</div>
            <h2 style="text-align: center; color: #0222a8;">Registration Confirmed</h2>
            <p>Dear ${data.name},</p>
            <p>Thank you for registering for the Xpand Elevate event! Your badge has been generated successfully.</p>
            <div class="info-box">
              <h3>Your Registration Details:</h3>
              <p><strong>Name:</strong> ${data.name}</p>
              <p><strong>Company:</strong> ${data.companyName}</p>
              <p><strong>Designation:</strong> ${data.businessField}</p>
              <p><strong>Email:</strong> ${data.email}</p>
              <p><strong>Phone:</strong> ${data.phone}</p>
            </div>
            <p>Your badge PDF has been opened in a new tab. Please save it and bring it with you to the event.</p>
            <p><strong>Important:</strong> Please present your badge at the registration desk upon arrival.</p>
            <p>We look forward to seeing you at the event!</p>
          </div>
          <div class="footer">
            <p>Xpand Elevate - Elevate Your Brand</p>
            <p>For any questions, please reply to this email.</p>
          </div>
        </div>
      </body>
      </html>
    `;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setSucceeded(false);
    setError(null);

    try {
      // Step 1: Submit data to Google Sheets
      const submissionData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        companyName: formData.companyName,
        companySite: formData.companySite,
        businessField: formData.businessField,
        timestamp: new Date().toISOString(),
      };

      // Step 3: Send email notifications in background (don't show status to user)
      // Email to admin
      // Email to user
      sendEmail(
        submissionData,
        "Your Badge is Ready - Xpand Elevate",
        formData.email,
        generateUserEmailTemplate(submissionData)
      ).catch((err) => console.log("User email failed:", err));

      sendEmail(
        submissionData,
        "New Badge Registration - Xpand Elevate",
        "herezainali@gmail.com",
        generateAdminEmailTemplate(submissionData)
      ).catch((err) => console.log("Admin email failed:", err));

      // Step 4: Reset form after all operations
      setFormData({
        name: "",
        email: "",
        phone: "",
        companyName: "",
        companySite: "",
        businessField: "",
        logo: null,
      });
      await fetch(
        "https://script.google.com/macros/s/AKfycbzWfDR9dWWxsbK6LRAmOJhPOfd_cEzRJkNBSQN0HoVEiQcC6E9TQtK_n2Azsb8oj479/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submissionData),
        }
      );

      // Step 2: Generate PDF
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      // Use Vercel backend URL for production, localhost for development
      const apiUrl =
        process.env.REACT_APP_API_URL ||
        (process.env.NODE_ENV === "production"
          ? "https://eventpdfgen-production.up.railway.app"
          : "http://localhost:5000");

      const res = await fetch(`${apiUrl}/generate-pdf`, {
        method: "POST",
        body: data,
      });

      if (!res.ok) {
        // Try to get error message from response
        let errorMessage = "Failed to generate PDF";
        try {
          const errorData = await res.json();
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (e) {
          // If response is not JSON, use status text
          errorMessage = `Failed to generate PDF: ${res.status} ${res.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      window.open(url);

      // PDF generated successfully - show success message
      setSucceeded(true);

      // Reset file input
      const fileInput = document.getElementById("logo");
      if (fileInput) {
        fileInput.value = "";
      }
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <h2>
              <img height={90} src={logo} alt="Xpand Elevate" />
            </h2>
          </div>
          <button
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
            <li className="mobile-menu-logo">
              <img src={logo} alt="Xpand Elevate" className="mobile-logo-img" />
            </li>
            <li>
              <a href="#home" onClick={(e) => handleSmoothScroll(e, "home")}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={(e) => handleSmoothScroll(e, "about")}>
                About
              </a>
            </li>
            <li>
              <a
                href="#mission"
                onClick={(e) => handleSmoothScroll(e, "mission")}
              >
                Mission
              </a>
            </li>
            <li>
              <a
                href="#journey"
                onClick={(e) => handleSmoothScroll(e, "journey")}
              >
                Journey
              </a>
            </li>
            {/* <li>
              <a
                href="#beginning"
                onClick={(e) => handleSmoothScroll(e, 'beginning')}
              >
                Beginning
              </a>
            </li> */}
            {/* <li>
              <a
                href="#leadership"
                onClick={(e) => handleSmoothScroll(e, 'leadership')}
              >
                Leadership Messages
              </a>
            </li> */}
            <li>
              <a
                href="#why-choose"
                onClick={(e) => handleSmoothScroll(e, "why-choose")}
              >
                Why Choose Xpand
              </a>
            </li>
            <li>
              <a
                href="#promise"
                onClick={(e) => handleSmoothScroll(e, "promise")}
              >
                Promise
              </a>
            </li>
            <li>
              <a
                href="#previous-events"
                onClick={(e) => handleSmoothScroll(e, "previous-events")}
              >
                Previous Events
              </a>
            </li>
            <li>
              <a
                href="#register"
                onClick={(e) => handleSmoothScroll(e, "register")}
                className="register-btn"
              >
                Register
              </a>
            </li>
          </ul>
          {isMenuOpen && (
            <div
              className="menu-backdrop"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-slideshow-container">
          <button
            className="slider-arrow slider-arrow-left"
            onClick={prevSlide}
            aria-label="Previous slide"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="hero-slideshow">
            {eventImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Event slide ${index + 1}`}
                className={`hero-slide ${
                  index === currentSlide ? "active" : ""
                }`}
              />
            ))}
          </div>
          <button
            className="slider-arrow slider-arrow-right"
            onClick={nextSlide}
            aria-label="Next slide"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Xpand Elevate</h2>
            <div className="title-underline"></div>
          </div>
          <div className="about-content">
            <div className="about-image">
              <div
                className="image-placeholder expo-image-2"
                style={{ backgroundImage: "url(" + Image3 + ")" }}
              ></div>
            </div>
            <div className="about-text">
              <p>
                Xpand Elevate specialises in designing and managing exceptional
                expo experiences that bring businesses, industries, and global
                communities together.
                <br />
                From solo country expos to large-scale business group
                exhibitions, international delegations, and official corporate
                events, we deliver end-to-end planning with unmatched precision,
                creativity, and professionalism.
              </p>
              <div className="features-grid">
                <div className="feature-card">
                  {/* <div className="feature-icon">🌍</div> */}
                  <h3>
                    Global <br /> Reach
                  </h3>
                  <p>International delegations and worldwide events</p>
                </div>
                <div className="feature-card">
                  {/* <div className="feature-icon">🎯</div> */}
                  <h3>Precision Planning</h3>
                  <p>End-to-end organization with unmatched accuracy</p>
                </div>
                <div className="feature-card">
                  {/* <div className="feature-icon"></div> */}
                  <h3>Creative Excellence</h3>
                  <p>Innovative concepts that make events memorable</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section id="mission" className="mission-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Mission</h2>
            <div className="title-underline"></div>
          </div>
          <div className="mission-content">
            <div className="mission-text">
              <p className="mission-statement">
                Our mission is to elevate every event through seamless
                organisation, innovative concepts, and a strong commitment to
                quality.
                <br />
                Whether you are showcasing your products, expanding your
                network, launching a business collaboration, or representing
                your country on an international platform.
                <br />
                Xpand Elevate ensures a professional, impactful, and memorable
                experience every time.
              </p>
              <div className="mission-values">
                <div className="value-item">
                  <h4>Seamless Organisation</h4>
                  <p>Every detail meticulously planned and executed</p>
                </div>
                <div className="value-item">
                  <h4>Innovative Concepts</h4>
                  <p>Creative solutions that set your event apart</p>
                </div>
              </div>
            </div>
            <div className="mission-image">
              <div
                className="image-placeholder expo-image-3"
                style={{ backgroundImage: "url(" + Image5 + ")" }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      {/* The Birth of Xpand Section */}
      <section id="journey" className="journey-combined-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">The Birth of Xpand – Our Journey</h2>
            <div className="title-underline"></div>
          </div>
          <div className="journey-rows">
            <div className="journey-row-card">
              <h3 className="row-card-title">The Birth of Xpand</h3>
              <p className="journey-text">
                Xpand was inspired by more than 17 years of successful event
                experience under the well known travel agency Al Wahdat Travel.
              </p>
            </div>
            <div className="journey-row-card">
              <h3 className="row-card-title">Where It All Began</h3>
              <p>
                For over 17 years, Al Wahdat Travel has been recognised as one
                of the leading travel agencies, trusted, established, and
                consistently successful.
              </p>
              <p>
                Beyond travel services, Al Wahdat organised several major events
                including:
              </p>
              <ul className="event-list">
                <li>Large corporate gatherings</li>
                <li>Business delegations</li>
                <li>International networking programs</li>
                <li>And their own Award Show held in Sukkur and Hyderabad.</li>
              </ul>
              <p className="milestone-text">
                <strong>one of the most memorable milestones</strong>
              </p>
              <p>
                These experiences shaped the foundation of what would later
                become Xpand.
              </p>
            </div>
            <div className="journey-row-card">
              <h3 className="row-card-title">
                Representing Pakistan Internationally
              </h3>
              <p>
                Al Wahdat Travel proudly represented Pakistan in Iran,
                delivering outstanding work at multiple expos and delegations.
              </p>
              <p>
                This international recognition proved that the team had the
                capability, vision, and experience needed to grow beyond a
                travel brand.
              </p>
            </div>
            <div className="journey-row-card">
              <h3 className="row-card-title">
                The Vision to Create Something Bigger
              </h3>
              <p>
                After years of organising complex delegations, exhibitions, and
                international programs, We realised:
              </p>
              <p className="vision-highlight">
                There is a need for a specialised, professional, world class
                event and expo management company in Pakistan.
              </p>
              <p>A company that could combine:</p>
              <ul className="vision-list">
                <li>17+ years of travel & event expertise</li>
                <li>International delegation experience</li>
                <li>Modern creative expo concepts</li>
                <li>Professional corporate standards</li>
              </ul>
              <p>
                And that dream became Xpand, a brand created to elevate every
                event to its highest potential.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* A New Beginning Section */}
      <section id="beginning" className="new-beginning-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">A New Beginning</h2>
            <div className="title-underline"></div>
          </div>
          <div className="new-beginning-columns">
            <div className="new-beginning-text">
              <p>
                Xpand officially began its journey during the Qazvin Solo Expo
                on 12-12-2025, followed by multiple delegation engagements.
              </p>
              <p>
                Earlier experiences. including challenges faced in 2023 taught
                the team valuable lessons that helped them build Xpand into a
                stronger, more refined, and globally competitive brand.
              </p>
              <p>Xpand was created so that businesses could easily organise:</p>
            </div>
            <div className="new-beginning-services">
              <ul className="services-list">
                <li>Solo country expos</li>
                <li>International exhibitions</li>
                <li>Corporate events</li>
                <li>Business delegations</li>
                <li>Seminars and conferences</li>
              </ul>
              <p>All with trust, quality, and excellence.</p>
              <p className="commitment-text">
                <strong>
                  We give our 100%, and we never give space for complaints.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Messages From Leadership Section */}
      <section id="leadership" className="leadership-messages-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Messages From Leadership</h2>
            <div className="title-underline"></div>
          </div>
          <div className="leadership-columns">
            {/* CEO Message */}
            <div className="leadership-column">
              <h3 className="column-title">
                Message From the CEO – Mr. Hasnain Homaey
              </h3>
              <div className="message-quote">
                <p className="quote-text">
                  "Xpand is the result of experience, passion, and a commitment
                  to excellence."
                </p>
              </div>
              <div className="message-body">
                <p>
                  For more than 17 years, I was deeply involved in organising
                  corporate events, international delegations, and large scale
                  programs under Al Wahdat Travel.
                </p>
                <p>
                  Every event taught me that businesses need more than just
                  arrangements. they need vision, strategy, global standards,
                  and flawless execution.
                </p>
                <p>Xpand was born from the desire to offer exactly that.</p>
                <p>
                  Our aim is simple:
                  <br />
                  To elevate every business, every brand, and every idea through
                  exceptional expo and event experiences.
                </p>
                <p>
                  Xpand is built on trust, expertise, and continuous
                  improvement. Every challenge we faced strengthened our
                  foundation. Every success pushed us to think bigger. Today,
                  Xpand stands as a symbol of quality, professionalism, and
                  limitless possibilities.
                </p>
                <p>
                  I welcome every organisation, every delegation, and every
                  dreamer to join us on this journey. Let's elevate your brand,
                  together.
                </p>
              </div>
              <div className="message-signature">
                <p>
                  <strong>Hasnain Homaey</strong>
                </p>
                <p>Chief Executive Officer, Xpand Elevate</p>
              </div>
            </div>

            {/* COO Message */}
            <div className="leadership-column">
              <h3 className="column-title">
                Message From the COO – Ms. Khizraan Fatima
              </h3>
              <div className="message-quote">
                <p className="quote-text">
                  "Xpand is not just a company, it's a step toward empowering
                  women and building a stronger future."
                </p>
              </div>
              <div className="message-body">
                <p>
                  From the very beginning, I believed in women empowerment. My
                  vision was simple: Women deserve opportunities to build better
                  lives, achieve their dreams, and become financially
                  independent.
                </p>
                <p>
                  When I joined hands to create Xpand, I made sure that
                  empowerment became a core part of our identity. Today, 80% of
                  our team consists of women, and this will continue to grow. We
                  aim to provide platforms, training, and real opportunities so
                  women can become stronger, confident, and successful.
                </p>
                <p>
                  My message to every woman is: If I can take this step, you can
                  too. Never stop dreaming. Never stop working. Success will
                  follow you.
                </p>
                <p>
                  Xpand is dedicated not only to delivering world class events,
                  but also to building a future where women can thrive in
                  leadership, creativity, business, and beyond.
                </p>
              </div>
              <div className="message-signature">
                <p>
                  <strong> Khizraan Fatima</strong>
                </p>
                <p>Chief Operating Officer, Xpand Elevate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Xpand Section */}
      <section id="why-choose" className="why-choose-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Xpand?</h2>
            <div className="title-underline"></div>
          </div>
          <div className="why-choose-content">
            <ul className="why-choose-list">
              <li>17+ years of event management and travel expertise</li>
              <li>International delegation experience</li>
              <li>Strong creative and strategic planning team</li>
              <li>Women led organisation with empowerment at the core</li>
              <li>100% commitment, professionalism, and quality</li>
              <li>Seamless execution for all types of events and expos</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Our Promise Section */}
      <section id="promise" className="promise-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Promise</h2>
            <div className="title-underline"></div>
          </div>
          <div className="promise-content">
            <p>
              Xpand is committed to delivering excellence, ensuring smooth
              execution, and creating unforgettable experiences.
            </p>
            <p>
              We aim to become the leading expo and event management brand
              trusted locally and internationally.
            </p>
            <div className="promise-footer">
              <p className="thankyou-text">THANKYOU</p>
              <p className="tagline-text">Xpand - (Elevate Your Brand).</p>
            </div>
          </div>
        </div>
      </section>

      {/* Previous Events Section */}
      <section id="previous-events" className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Previous Events</h2>
            <div className="title-underline"></div>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-image">
                <div
                  className="image-placeholder service-img-1"
                  style={{
                    backgroundImage: "url(" + eventImage1 + ")",
                  }}
                ></div>
              </div>
              <h3>Iran Solo Country / Iran–Pak Expo</h3>
              <p>Showcasing national excellence and bilateral relations</p>
            </div>
            <div className="service-card">
              <div className="service-image">
                <div
                  className="image-placeholder service-img-2"
                  style={{
                    backgroundImage: "url(" + eventImage2 + ")",
                  }}
                ></div>
              </div>
              <h3>
                Showcase Irani Famous Artist ,Wooden Art Work at Art Council.
              </h3>
              <p>Official showcase event with distinguished guests</p>
            </div>
            <div className="service-card">
              <div className="service-image">
                <div
                  className="image-placeholder service-img-3"
                  style={{ backgroundImage: "url(" + eventImage3 + ")" }}
                ></div>
              </div>
              <h3>
                Showcase Mashadd-e-MuqadasCulture and Art with Honourable
                Governor Of Mashad at Expo Center Karachi
              </h3>
              <p>Cultural exhibition celebrating artistic excellence</p>
            </div>
            <div className="service-card">
              <div className="service-image">
                <div
                  className="image-placeholder service-img-4"
                  style={{
                    backgroundImage: "url(" + eventImage4 + ")",
                  }}
                ></div>
              </div>
              <h3>
                Sukkur and Hyderabad Event of the Award Show and the Iran–Pak
                Tourism Conference
              </h3>
              <p>Multi-city event celebrating tourism and achievements</p>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Form Section */}
      <section id="register" className="register-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Register & Generate Your Badge</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Join us for an exceptional expo experience. Register now and
              generate your personalized badge.
            </p>
          </div>
          <div className="form-container">
            <form onSubmit={handleSubmit} className="registration-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                    maxLength="35"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    maxLength="50"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    maxLength="20"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="companyName">Company Name</label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    placeholder="Enter your company name"
                    value={formData.companyName}
                    onChange={handleChange}
                    maxLength="35"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="companySite">Company Website</label>
                  <input
                    type="text"
                    id="companySite"
                    name="companySite"
                    placeholder="yourcompany.com"
                    value={formData.companySite}
                    onChange={handleChange}
                    maxLength="35"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="businessField">Your Designation</label>
                  <input
                    type="text"
                    id="businessField"
                    name="businessField"
                    placeholder="Enter your designation"
                    value={formData.businessField}
                    onChange={handleChange}
                    maxLength="35"
                    required
                  />
                </div>
              </div>

              <div className="form-group file-upload-group">
                <label htmlFor="logo">Company Logo</label>
                <div className="file-upload-wrapper">
                  <input
                    type="file"
                    id="logo"
                    accept="image/*"
                    onChange={handleLogoUpload}
                  />
                  <span className="file-upload-text">
                    {formData.logo ? formData.logo.name : "Choose logo file"}
                  </span>
                </div>
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isProcessing}
              >
                {isProcessing ? "Processing..." : "Generate PDF Badge"}
              </button>

              {succeeded && (
                <div className="form-message form-message-success">
                  ✓ Badge generated successfully!
                </div>
              )}
              {error && (
                // <div className="form-message form-message-error">⚠ {error}</div>
                <span></span>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-brand">
                <img
                  width={500}
                  src={logo}
                  alt="Xpand Elevate"
                  className="footer-logo-img"
                />
              </div>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#mission">Mission</a>
                </li>
                <li>
                  <a href="#register">Register</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>Ready to elevate your next event?</p>
              <p>Get in touch with us today.</p>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-al-wahdat">
              <img
                src={logopng}
                alt="Al Wahdat Travel"
                className="al-wahdat-logo"
              />
              <p>Project of Al Wahdat Travel Group(AWTG)</p>
            </div>
            <p>&copy; 2025 Xpand Elevate. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
